import React from 'react';
import { View } from 'react-native-web';
import {
  addPathToList, configure_screen_option,
  getSubCategoryId, installment_options_alignment_text,
  installment_options_column_text,
  installment_options_layout, installment_options_title, select_installment_option,
} from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import RadioPanelAdvance from '../components/PanelsComponents/Buttons/RadioPanelAdvance';

const Panel_J04_LoanInstallmentOptions = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onGotoEdit,
  onStepPressed,
  language,
}) => {
  const editTextList = [
    'select_loan_option',
  ];
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const service = globJSON.configurations.services[subCategoryId];
  const { option } = service;
  const onValueChanged = (key, value) => {
    option[key] = value;
    onConfigChanged();
  };
  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      onGotoEdit={onGotoEdit}
      panelHeadline={installment_options_title}
      panelSubHeadline={select_installment_option}
      editTextList={addPathToList(editTextList, `configurations/services/${subCategoryId}/option/`)}
      tooltipsTitles={service.screens_ordering}
      paragraph={configure_screen_option}
      language={language}
    >

      <View>
        <RadioPanelAdvance
          title={installment_options_layout}
          chosenValue={option.multiple_columns}
          valuesMap={installment_options_column_text}
          onValueChanged={(value) => {
            onValueChanged('multiple_columns', value);
          }}
        />
        <RadioPanelAdvance
          chosenValue={option.content_aligned_center}
          valuesMap={installment_options_alignment_text}
          onValueChanged={(value) => {
            onValueChanged('content_aligned_center', value);
          }}
        />
      </View>
    </FullPagePanel>
  );
};

export default Panel_J04_LoanInstallmentOptions;
